export default __webpack_public_path__ + "static/media/logo-hor.175fec49.png";